import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { accessibilityParamsStore } from 'stores/root/instance';
import { Color } from 'types/colors';
import { getColor } from 'utils/getColor';

import { TypoTextAlign, TypoWeight, TypoView, TypoElement } from './config';

import s from './Typo.module.scss';

export type TypoProps = {
  element?: TypoElement;
  uppercase?: boolean;
  block?: boolean;
  maxLines?: number;
  className?: string;
  style?: React.CSSProperties;
  view?: TypoView;
  textAlign?: TypoTextAlign;
  children: React.ReactNode;
  weight?: TypoWeight;
  color?: Color;
  onMouseOver?: VoidFunction;
  onMouseOut?: VoidFunction;
  role?: React.AriaRole;
  title?: string;
} & React.AriaAttributes;

const Typo = React.forwardRef<any, TypoProps>(
  (
    {
      element: Element = 'div',
      view = 'body-1',
      children,
      textAlign,
      maxLines,
      block,
      uppercase,
      className,
      weight,
      color,
      title,
      ...props
    },
    ref
  ) => {
    const { isOpen: isAccessibilityActive } = accessibilityParamsStore;

    return (
      <Element
        ref={ref}
        className={cn(
          s['typo'],
          view && s[`typo_view_${view}`],
          weight && s[`typo_weight_${weight}`],
          textAlign && s[`typo_text-align_${textAlign}`],
          maxLines === 1 && s['typo_ellipsis'],
          maxLines && maxLines > 1 && s['typo_multi-ellipsis'],
          block && s['typo_block'],
          uppercase && s['typo_uppercase'],
          isAccessibilityActive && s['typo_accessibility'],
          className
        )}
        title={title}
        style={
          {
            '--max-lines-count': maxLines,
            '--typo-color': color ? getColor(color) : undefined,
          } as React.CSSProperties
        }
        {...props}
      >
        {children}
      </Element>
    );
  }
);

export default observer(Typo);
